export default __webpack_public_path__ + "static/media/list_view_icon_red.f3335812.svg";